{
 "version": 1,
 "generator": "tools/make-materials.mjs",
 "generator_sha": "d3302c09d7358138b735f6c6e88b1a2bbb79a7a8b5014f7653bfb4b9e7062014",
 "tiers": {
  "t1": {
   "size": 512
  },
  "t2": {
   "size": 1024
  }
 },
 "packing": {
  "A": "rgb = albedo multiplier / 2 (mean 0.5 == x1), a = height 0..1",
  "B": "r,g = 0.5 + 0.5 * normal x (+u = east), z (+v = south); b = cavity multiplier / 2; a = 255",
  "color": "linear, no sRGB transfer; UASTC + zstd; mips linear + wrapped; no Y flip"
 },
 "layers": [
  {
   "key": "grass",
   "source": "procedural",
   "m_per_tile": 3,
   "classes": [
    0,
    8,
    9,
    10
   ],
   "contrast": 1,
   "normal_k": 1,
   "cavity_k": 1,
   "files": {
    "t2_A": {
     "file": "t2/A_grass.ktx2",
     "bytes": 1160255,
     "sha256": "630756bbb08a6fee1e2cd6789c5c34239d4d1223693b62d2bb7e5cc02b39a45c"
    },
    "t2_B": {
     "file": "t2/B_grass.ktx2",
     "bytes": 1171556,
     "sha256": "91e3629a7fc33ff26b652cc52b7fb7f51722d8552cce51155b617ca3d4a4b1d9"
    },
    "t1_A": {
     "file": "t1/A_grass.ktx2",
     "bytes": 266508,
     "sha256": "c6bc8cb88d9d10f7596ac635b1be6a9fc7e602158efa63c7ca22ff42ab68d5e0"
    },
    "t1_B": {
     "file": "t1/B_grass.ktx2",
     "bytes": 296656,
     "sha256": "89d20784d1e0206101b1b02a948c638db24acbb801f54c09a5d4a92e95283338"
    }
   },
   "stats": {
    "t2": {
     "mult_mean": [
      1,
      1,
      1
     ],
     "mult_logstd": [
      0.166,
      0.143,
      0.157
     ],
     "normal_mean": [
      0,
      0
     ],
     "tilt_deg": 11.4,
     "cavity_mean": 1,
     "height_range_m": 0.0203,
     "c_fine": 0.0388,
     "c_mid": 0.0413
    },
    "t1": {
     "mult_mean": [
      1,
      1,
      1
     ],
     "mult_logstd": [
      0.16,
      0.136,
      0.151
     ],
     "normal_mean": [
      0,
      0
     ],
     "tilt_deg": 6.5,
     "cavity_mean": 1,
     "height_range_m": 0.0203,
     "c_fine": 0.0388,
     "c_mid": 0.0413
    }
   },
   "target": {
    "c_fine": 0.039,
    "c_mid": 0.04,
    "preview": [
     0.1,
     0.15,
     0.045
    ]
   }
  },
  {
   "key": "turf",
   "source": "procedural",
   "m_per_tile": 2.5,
   "classes": [
    1
   ],
   "contrast": 1,
   "normal_k": 1,
   "cavity_k": 1,
   "files": {
    "t2_A": {
     "file": "t2/A_turf.ktx2",
     "bytes": 1115847,
     "sha256": "e6f048e15d87b558bc5f9f2092e08792b92bf187c5d45a69674826abe9fad59c"
    },
    "t2_B": {
     "file": "t2/B_turf.ktx2",
     "bytes": 1172076,
     "sha256": "46ea05092a0b0c57f6230e043b17709a0f77988b844f64d93232d4169997942a"
    },
    "t1_A": {
     "file": "t1/A_turf.ktx2",
     "bytes": 251913,
     "sha256": "08f323c2fee1f37d3ced9a833576829e29f6f9dd5bf02f6521fa0e7e102468a6"
    },
    "t1_B": {
     "file": "t1/B_turf.ktx2",
     "bytes": 297875,
     "sha256": "9f5eab55ca926e3bd41ab877b38e13e1cf2d8bb226ac897c030f209323343476"
    }
   },
   "stats": {
    "t2": {
     "mult_mean": [
      1,
      1,
      1
     ],
     "mult_logstd": [
      0.199,
      0.183,
      0.195
     ],
     "normal_mean": [
      0,
      0
     ],
     "tilt_deg": 11.1,
     "cavity_mean": 1,
     "height_range_m": 0.0225,
     "c_fine": 0.0568,
     "c_mid": 0.051
    },
    "t1": {
     "mult_mean": [
      1,
      1,
      1
     ],
     "mult_logstd": [
      0.196,
      0.179,
      0.191
     ],
     "normal_mean": [
      0,
      0
     ],
     "tilt_deg": 7.1,
     "cavity_mean": 1,
     "height_range_m": 0.0225,
     "c_fine": 0.0568,
     "c_mid": 0.051
    }
   },
   "target": {
    "c_fine": 0.057,
    "c_mid": 0.053,
    "preview": [
     0.12,
     0.13,
     0.05
    ]
   }
  },
  {
   "key": "heath",
   "source": "procedural",
   "m_per_tile": 2.5,
   "classes": [
    2
   ],
   "contrast": 1,
   "normal_k": 1,
   "cavity_k": 1,
   "files": {
    "t2_A": {
     "file": "t2/A_heath.ktx2",
     "bytes": 985436,
     "sha256": "718a21b4483baefb41babda8b21d5262201f93c5ea18e2ed83aba2cfc858f75b"
    },
    "t2_B": {
     "file": "t2/B_heath.ktx2",
     "bytes": 1089328,
     "sha256": "ec6acb2b08b06de4a301dfc40a476adb34693471a478127479145513c70f17ba"
    },
    "t1_A": {
     "file": "t1/A_heath.ktx2",
     "bytes": 273378,
     "sha256": "5b666b48dbf30b9d2069165e78c92d26cbf3957d48863fa8b4ca67152a870dec"
    },
    "t1_B": {
     "file": "t1/B_heath.ktx2",
     "bytes": 299880,
     "sha256": "70dc6fb763965b99dc97ca0b0ac7efea565caf81da8a584d68579520abc81e69"
    }
   },
   "stats": {
    "t2": {
     "mult_mean": [
      1,
      1,
      0.999
     ],
     "mult_logstd": [
      0.305,
      0.366,
      0.288
     ],
     "normal_mean": [
      0.001,
      -0.001
     ],
     "tilt_deg": 25.5,
     "cavity_mean": 1,
     "height_range_m": 0.0746,
     "c_fine": 0.0967,
     "c_mid": 0.0385
    },
    "t1": {
     "mult_mean": [
      1,
      1,
      0.999
     ],
     "mult_logstd": [
      0.299,
      0.361,
      0.282
     ],
     "normal_mean": [
      0.001,
      -0.001
     ],
     "tilt_deg": 24,
     "cavity_mean": 1,
     "height_range_m": 0.0746,
     "c_fine": 0.0967,
     "c_mid": 0.0385
    }
   }
  },
  {
   "key": "forest",
   "source": "scan",
   "m_per_tile": 2,
   "classes": [
    3
   ],
   "contrast": 0.75,
   "normal_k": 1,
   "cavity_k": 1,
   "files": {
    "t2_A": {
     "file": "t2/A_forest.ktx2",
     "bytes": 1363535,
     "sha256": "c4e89508ca5ba8dc797e3c5718b0ad6260505e3ab300b202fe0d9225fd4f3f7a"
    },
    "t2_B": {
     "file": "t2/B_forest.ktx2",
     "bytes": 1323039,
     "sha256": "de7c7beef6f264bb9821333ce5c2d8851046709a8b9a59bb2bb5264cefce6294"
    },
    "t1_A": {
     "file": "t1/A_forest.ktx2",
     "bytes": 322188,
     "sha256": "efb093774be0ad3d5ecc114d5282d07b1a9dee63f18716b7ed0e44300a25726b"
    },
    "t1_B": {
     "file": "t1/B_forest.ktx2",
     "bytes": 308859,
     "sha256": "cb61f33d2d874139249e5b0575a7661bee2124aa39089be53db23a09c1822cad"
    }
   },
   "stats": {
    "t2": {
     "mult_mean": [
      1,
      1,
      1
     ],
     "mult_logstd": [
      0.257,
      0.314,
      0.397
     ],
     "normal_mean": [
      0,
      0
     ],
     "tilt_deg": 21.1,
     "cavity_mean": 1,
     "height_range_m": 0.011,
     "c_fine": 0.0109,
     "c_mid": 0.0026
    },
    "t1": {
     "mult_mean": [
      1,
      1,
      1
     ],
     "mult_logstd": [
      0.17,
      0.196,
      0.243
     ],
     "normal_mean": [
      0,
      0
     ],
     "tilt_deg": 11.9,
     "cavity_mean": 1,
     "height_range_m": 0.011,
     "c_fine": 0.0109,
     "c_mid": 0.0026
    }
   },
   "scan": {
    "id": "forrest_ground_03",
    "author": "Rob Tuytel",
    "url": "https://polyhaven.com/a/forrest_ground_03",
    "license": "CC0-1.0",
    "resolution": "2k",
    "sha256": {
     "diff": "187a8e33773473939c0e85b5e10ae94eb9e8d91463ab8b74e122d833d2d84dc6",
     "disp": "306710e18fb0bd35ef74ee5931d3781373ea5c870409b2084b5da0801cd23da5",
     "nor_gl": "dcc26b4fd27a8e1f1f14558214fbaf1d68a61d9b569eee805793498e4b30098c"
    }
   }
  },
  {
   "key": "scree",
   "source": "procedural",
   "m_per_tile": 5,
   "classes": [
    4
   ],
   "contrast": 1,
   "normal_k": 1,
   "cavity_k": 1,
   "files": {
    "t2_A": {
     "file": "t2/A_scree.ktx2",
     "bytes": 1093609,
     "sha256": "18302e5a75bc70b4a2f8602d943ff56b9afc1e37764b0f8ec5028409cdb84b9c"
    },
    "t2_B": {
     "file": "t2/B_scree.ktx2",
     "bytes": 1158832,
     "sha256": "0df0e305ad0cb6ba4b827ab1f953296fdd9481b3dd825c957c023d4981586d46"
    },
    "t1_A": {
     "file": "t1/A_scree.ktx2",
     "bytes": 266818,
     "sha256": "ab47e7ced1f45b5417c795684afd4f3bbeaa50dd61f353ee05d9bf7a09c23324"
    },
    "t1_B": {
     "file": "t1/B_scree.ktx2",
     "bytes": 312954,
     "sha256": "7bb43ceb77721cf952344655b4d9c38fcc38d5a863e21eebb88b619a583adcbf"
    }
   },
   "stats": {
    "t2": {
     "mult_mean": [
      1,
      1,
      1
     ],
     "mult_logstd": [
      0.514,
      0.511,
      0.522
     ],
     "normal_mean": [
      -0.008,
      0.001
     ],
     "tilt_deg": 37.3,
     "cavity_mean": 1,
     "height_range_m": 0.634,
     "c_fine": 0.135,
     "c_mid": 0.1053
    },
    "t1": {
     "mult_mean": [
      1,
      1,
      1
     ],
     "mult_logstd": [
      0.498,
      0.495,
      0.505
     ],
     "normal_mean": [
      -0.008,
      0.001
     ],
     "tilt_deg": 35.9,
     "cavity_mean": 1,
     "height_range_m": 0.634,
     "c_fine": 0.135,
     "c_mid": 0.1053
    }
   }
  },
  {
   "key": "rock",
   "source": "procedural",
   "m_per_tile": 4,
   "classes": [
    5
   ],
   "contrast": 1,
   "normal_k": 1.4,
   "cavity_k": 1.4,
   "files": {
    "t2_A": {
     "file": "t2/A_rock.ktx2",
     "bytes": 779262,
     "sha256": "3fa1c1b3e37b8f9f4a28e15092b648bafee16d5bfc58140722253bf0551bcab4"
    },
    "t2_B": {
     "file": "t2/B_rock.ktx2",
     "bytes": 1114256,
     "sha256": "a1a16ca8bbb9edd27a9461ce0e674aadc9eaaed38a59c4fc8fad545d4190a120"
    },
    "t1_A": {
     "file": "t1/A_rock.ktx2",
     "bytes": 216322,
     "sha256": "286fab5ba9c369b8486842091afcf7202224cd1178e613851e74684d203179ae"
    },
    "t1_B": {
     "file": "t1/B_rock.ktx2",
     "bytes": 287283,
     "sha256": "000fde23769fd491f6b503a0b612284edfd0290512daabd4767321d854820ff5"
    }
   },
   "stats": {
    "t2": {
     "mult_mean": [
      1,
      1,
      1
     ],
     "mult_logstd": [
      0.202,
      0.205,
      0.403
     ],
     "normal_mean": [
      0.008,
      0.005
     ],
     "tilt_deg": 30.9,
     "cavity_mean": 1,
     "height_range_m": 0.2535,
     "c_fine": 0.0462,
     "c_mid": 0.0296
    },
    "t1": {
     "mult_mean": [
      1,
      1,
      1
     ],
     "mult_logstd": [
      0.197,
      0.2,
      0.396
     ],
     "normal_mean": [
      0.008,
      0.005
     ],
     "tilt_deg": 29.7,
     "cavity_mean": 1,
     "height_range_m": 0.2535,
     "c_fine": 0.0462,
     "c_mid": 0.0296
    }
   }
  },
  {
   "key": "gravel",
   "source": "procedural",
   "m_per_tile": 1.5,
   "classes": [
    6,
    14
   ],
   "contrast": 1,
   "normal_k": 1,
   "cavity_k": 1,
   "files": {
    "t2_A": {
     "file": "t2/A_gravel.ktx2",
     "bytes": 977646,
     "sha256": "4b4f35f8d31ea39c3c12b0e9fbaff3df01ec48b5d645fe01e7050316dee72f0f"
    },
    "t2_B": {
     "file": "t2/B_gravel.ktx2",
     "bytes": 1148774,
     "sha256": "48e985e16070a1cf662dd965285f2d03e4061d5f903b06b428d0e8cbe8684935"
    },
    "t1_A": {
     "file": "t1/A_gravel.ktx2",
     "bytes": 275451,
     "sha256": "9c015a6ebbb7a1443c025a492260f65a9ead243bcdfcedcd64171ba66552a5f7"
    },
    "t1_B": {
     "file": "t1/B_gravel.ktx2",
     "bytes": 289468,
     "sha256": "50ae78855fafa4a854fdb664607f85b29cafe8003d3f44ad73162fa49a5b7854"
    }
   },
   "stats": {
    "t2": {
     "mult_mean": [
      1,
      1,
      1
     ],
     "mult_logstd": [
      0.319,
      0.307,
      0.297
     ],
     "normal_mean": [
      0,
      0
     ],
     "tilt_deg": 23.1,
     "cavity_mean": 1,
     "height_range_m": 0.0204,
     "c_fine": 0.035,
     "c_mid": 0.0086
    },
    "t1": {
     "mult_mean": [
      1,
      1,
      1
     ],
     "mult_logstd": [
      0.308,
      0.296,
      0.286
     ],
     "normal_mean": [
      0,
      0
     ],
     "tilt_deg": 21.8,
     "cavity_mean": 1,
     "height_range_m": 0.0204,
     "c_fine": 0.035,
     "c_mid": 0.0086
    }
   }
  },
  {
   "key": "wetland",
   "source": "procedural",
   "m_per_tile": 3,
   "classes": [
    7
   ],
   "contrast": 1,
   "normal_k": 1,
   "cavity_k": 1,
   "files": {
    "t2_A": {
     "file": "t2/A_wetland.ktx2",
     "bytes": 1137403,
     "sha256": "a95935f67e56a2229394b33151739a724edcf530ea22b6d0ae47fb683c883ab1"
    },
    "t2_B": {
     "file": "t2/B_wetland.ktx2",
     "bytes": 1247971,
     "sha256": "76e9bb485dc356aa2b41319928d29f4cdc4d8b52dd130a4a60f16d7c55ed7e08"
    },
    "t1_A": {
     "file": "t1/A_wetland.ktx2",
     "bytes": 308416,
     "sha256": "d4ea8876af764a4a4b3bccf8c997f2a6ce08c21b663eb2465537f0e3c3958321"
    },
    "t1_B": {
     "file": "t1/B_wetland.ktx2",
     "bytes": 313277,
     "sha256": "8b56eb204ec547e2bd2ac4d6d86e4e0d50661e1666f35ba20383f95582f24cc9"
    }
   },
   "stats": {
    "t2": {
     "mult_mean": [
      1,
      1,
      1
     ],
     "mult_logstd": [
      0.445,
      0.343,
      0.437
     ],
     "normal_mean": [
      0.001,
      0
     ],
     "tilt_deg": 27,
     "cavity_mean": 1,
     "height_range_m": 0.101,
     "c_fine": 0.0957,
     "c_mid": 0.0368
    },
    "t1": {
     "mult_mean": [
      1,
      1,
      1
     ],
     "mult_logstd": [
      0.407,
      0.316,
      0.39
     ],
     "normal_mean": [
      0.001,
      0
     ],
     "tilt_deg": 21.3,
     "cavity_mean": 1,
     "height_range_m": 0.101,
     "c_fine": 0.0957,
     "c_mid": 0.0368
    }
   }
  },
  {
   "key": "dirt",
   "source": "scan",
   "m_per_tile": 1.3,
   "classes": [
    11
   ],
   "contrast": 0.6,
   "normal_k": 1,
   "cavity_k": 1,
   "files": {
    "t2_A": {
     "file": "t2/A_dirt.ktx2",
     "bytes": 1364253,
     "sha256": "8899b1175a156fb964a5ff65001150cd02839f4714a6633ae086003342f41510"
    },
    "t2_B": {
     "file": "t2/B_dirt.ktx2",
     "bytes": 1261142,
     "sha256": "af73230f834229ec41afed19c251af0fe6a78719c048307a1186473aee56d967"
    },
    "t1_A": {
     "file": "t1/A_dirt.ktx2",
     "bytes": 343488,
     "sha256": "2e64edb6ef842a5add7d41785da41fc65bce164f89628a1d40dd6516910a2af7"
    },
    "t1_B": {
     "file": "t1/B_dirt.ktx2",
     "bytes": 319759,
     "sha256": "3e0a5cd720ea9f45d9ae14e8ebb0a54b6ecabab5fe120cd49794707ae9eb1d7e"
    }
   },
   "stats": {
    "t2": {
     "mult_mean": [
      1,
      1,
      1
     ],
     "mult_logstd": [
      0.408,
      0.44,
      0.473
     ],
     "normal_mean": [
      0,
      0
     ],
     "tilt_deg": 23.5,
     "cavity_mean": 1,
     "height_range_m": 0.0148,
     "c_fine": 0.019,
     "c_mid": 0.0054
    },
    "t1": {
     "mult_mean": [
      1,
      1,
      1
     ],
     "mult_logstd": [
      0.333,
      0.348,
      0.376
     ],
     "normal_mean": [
      0,
      0
     ],
     "tilt_deg": 19.4,
     "cavity_mean": 1,
     "height_range_m": 0.0148,
     "c_fine": 0.019,
     "c_mid": 0.0054
    }
   },
   "scan": {
    "id": "brown_mud_dry",
    "author": "Rob Tuytel",
    "url": "https://polyhaven.com/a/brown_mud_dry",
    "license": "CC0-1.0",
    "resolution": "2k",
    "sha256": {
     "diff": "5f567f61a7e139101441a1209e9c174a4f92dce489b28bb168f6bfd0ca07e411",
     "disp": "2605b77d118300ca1529c8465cf999edb75f7de5a73fe873842cce7cd60c5c9a",
     "nor_gl": "b2cc46b8497f1c4a1e9cd51883175b1ae1c4eb8862c553573efb41ca0a4088bc"
    }
   }
  },
  {
   "key": "snow",
   "source": "procedural",
   "m_per_tile": 4,
   "classes": [
    15
   ],
   "contrast": 1,
   "normal_k": 1,
   "cavity_k": 0.5,
   "files": {
    "t2_A": {
     "file": "t2/A_snow.ktx2",
     "bytes": 387448,
     "sha256": "322fde65962409404ec45a1e81cfd5c6dffa84d74a8b9bd99763c4a096be0aea"
    },
    "t2_B": {
     "file": "t2/B_snow.ktx2",
     "bytes": 857109,
     "sha256": "d46002ec0ca755bab56aeb5145a5f66ea2f08fb68e92e86d16ba1b65b8fa7aee"
    },
    "t1_A": {
     "file": "t1/A_snow.ktx2",
     "bytes": 115149,
     "sha256": "756ee2e624542514cab3f9eb4d46e24e26f5916cae0cd450d5b3401dc4feb090"
    },
    "t1_B": {
     "file": "t1/B_snow.ktx2",
     "bytes": 221645,
     "sha256": "b5c6c35de17c761b3e32f39cc89e5b655faf1d39f03e810c4427ada98ce44038"
    }
   },
   "stats": {
    "t2": {
     "mult_mean": [
      1,
      1,
      1
     ],
     "mult_logstd": [
      0.006,
      0.004,
      0.006
     ],
     "normal_mean": [
      0,
      0
     ],
     "tilt_deg": 5,
     "cavity_mean": 1,
     "height_range_m": 0.0295,
     "c_fine": 0.0004,
     "c_mid": 0.0001
    },
    "t1": {
     "mult_mean": [
      1,
      1,
      1
     ],
     "mult_logstd": [
      0.006,
      0.004,
      0.006
     ],
     "normal_mean": [
      0,
      0
     ],
     "tilt_deg": 4,
     "cavity_mean": 1,
     "height_range_m": 0.0295,
     "c_fine": 0.0004,
     "c_mid": 0.0001
    }
   }
  },
  {
   "key": "paved",
   "source": "procedural",
   "m_per_tile": 2,
   "classes": [
    13
   ],
   "contrast": 1,
   "normal_k": 1,
   "cavity_k": 1,
   "files": {
    "t2_A": {
     "file": "t2/A_paved.ktx2",
     "bytes": 938406,
     "sha256": "ded02751d800203fc575cbe5193f18b30d6c62e69e063e33cd7e37481dbfc785"
    },
    "t2_B": {
     "file": "t2/B_paved.ktx2",
     "bytes": 811047,
     "sha256": "e29d73b5b26b8a92a0735ccf712d86cf1a3444b22158a245ab83d3e01ad3353d"
    },
    "t1_A": {
     "file": "t1/A_paved.ktx2",
     "bytes": 242184,
     "sha256": "56101d254e96e76c8c3e90dd79bf18fd85bbd7a244d11eb750b481fccda965ce"
    },
    "t1_B": {
     "file": "t1/B_paved.ktx2",
     "bytes": 227317,
     "sha256": "8f4b89cb1a1a1d05f5f3d8c68fe748a0f48d1f0b17d470645e68d97cafc7757b"
    }
   },
   "stats": {
    "t2": {
     "mult_mean": [
      1,
      1,
      1
     ],
     "mult_logstd": [
      0.31,
      0.316,
      0.481
     ],
     "normal_mean": [
      0,
      0
     ],
     "tilt_deg": 18.4,
     "cavity_mean": 1,
     "height_range_m": 0.0159,
     "c_fine": 0.0254,
     "c_mid": 0.0051
    },
    "t1": {
     "mult_mean": [
      1,
      1,
      1
     ],
     "mult_logstd": [
      0.302,
      0.307,
      0.469
     ],
     "normal_mean": [
      0,
      0
     ],
     "tilt_deg": 17.8,
     "cavity_mean": 1,
     "height_range_m": 0.0159,
     "c_fine": 0.0254,
     "c_mid": 0.0051
    }
   }
  },
  {
   "key": "trail_soil",
   "source": "scan",
   "m_per_tile": 2,
   "classes": [],
   "contrast": 0.75,
   "normal_k": 1,
   "cavity_k": 1,
   "files": {
    "t2_A": {
     "file": "t2/A_trail_soil.ktx2",
     "bytes": 1208557,
     "sha256": "0dc68c259dd97458a275e4524d1fb675927b7dfba7b708ddaf6564c07b756853"
    },
    "t2_B": {
     "file": "t2/B_trail_soil.ktx2",
     "bytes": 1214777,
     "sha256": "f45de4b00d16125fa1c5fe8ea895ade5da37681ddf668b6b3a897456682e37e1"
    },
    "t1_A": {
     "file": "t1/A_trail_soil.ktx2",
     "bytes": 292380,
     "sha256": "c04aed42af38dda6052f9515c5e3fe819fa0fdaba25e1859e94e2cfd86c55ca4"
    },
    "t1_B": {
     "file": "t1/B_trail_soil.ktx2",
     "bytes": 303429,
     "sha256": "903768a21d41e23eff6d16a50c923f0c243bf275e06aa7e5091939d3754c9989"
    }
   },
   "stats": {
    "t2": {
     "mult_mean": [
      1,
      1,
      1
     ],
     "mult_logstd": [
      0.105,
      0.126,
      0.149
     ],
     "normal_mean": [
      0,
      0
     ],
     "tilt_deg": 11.2,
     "cavity_mean": 1,
     "height_range_m": 0.0042,
     "c_fine": 0.0082,
     "c_mid": 0.0011
    },
    "t1": {
     "mult_mean": [
      1,
      1,
      1
     ],
     "mult_logstd": [
      0.083,
      0.102,
      0.12
     ],
     "normal_mean": [
      0,
      0
     ],
     "tilt_deg": 7.7,
     "cavity_mean": 1,
     "height_range_m": 0.0042,
     "c_fine": 0.0082,
     "c_mid": 0.0011
    }
   },
   "scan": {
    "id": "forest_ground_05",
    "author": "Charlotte Baglioni",
    "url": "https://polyhaven.com/a/forest_ground_05",
    "license": "CC0-1.0",
    "resolution": "2k",
    "sha256": {
     "diff": "5a626d6512200a868a0c03bad046076ff07c60ab8ead6f4af9d5fa82c1bc09c6",
     "disp": "6dae63182d5b11799990aba1f2a4949e3fc1113e5b6120c71b58dc6f20f9cef7",
     "nor_gl": "55f8c6675c20c69da33c6daa2052580746996441feae3de53c9b720b3b4fcc49"
    }
   }
  },
  {
   "key": "trail_rock",
   "source": "scan",
   "m_per_tile": 2,
   "classes": [],
   "contrast": 0.7,
   "normal_k": 1,
   "cavity_k": 1,
   "files": {
    "t2_A": {
     "file": "t2/A_trail_rock.ktx2",
     "bytes": 1252533,
     "sha256": "74395b80e653740dd9497429565fa5cfcea6345dca943e6495a175be3896f21e"
    },
    "t2_B": {
     "file": "t2/B_trail_rock.ktx2",
     "bytes": 1239163,
     "sha256": "7195eb4cbb637564c11d26aafa4df3b961f333088f757349971d8949f52cdf6b"
    },
    "t1_A": {
     "file": "t1/A_trail_rock.ktx2",
     "bytes": 312530,
     "sha256": "6d9f95cf8c9230b0249ec3f795de7c701f031176524bc37d3532dcfab7e8f34b"
    },
    "t1_B": {
     "file": "t1/B_trail_rock.ktx2",
     "bytes": 308050,
     "sha256": "4cf49c4e18ab90371625bd18d3dc75da21a377be18e8032120dc661e968583d1"
    }
   },
   "stats": {
    "t2": {
     "mult_mean": [
      1,
      1,
      1
     ],
     "mult_logstd": [
      0.197,
      0.193,
      0.202
     ],
     "normal_mean": [
      0,
      0
     ],
     "tilt_deg": 16,
     "cavity_mean": 1,
     "height_range_m": 0.0236,
     "c_fine": 0.0147,
     "c_mid": 0.0012
    },
    "t1": {
     "mult_mean": [
      1,
      1,
      1
     ],
     "mult_logstd": [
      0.164,
      0.16,
      0.171
     ],
     "normal_mean": [
      0,
      0
     ],
     "tilt_deg": 11.8,
     "cavity_mean": 1,
     "height_range_m": 0.0236,
     "c_fine": 0.0147,
     "c_mid": 0.0012
    }
   },
   "scan": {
    "id": "rock_path",
    "author": "Amal Kumar",
    "url": "https://polyhaven.com/a/rock_path",
    "license": "CC0-1.0",
    "resolution": "2k",
    "sha256": {
     "diff": "ce1be6a2165c3acca60eb081d60c77425a02bf05e9f45b749916a6b2e496e465",
     "disp": "4d75549937e50795102ae7e247e4b92ad3fc878dc09f5905d6ebb193c194ca3a",
     "nor_gl": "0f71c5311f3f234afd7da6b6958deb0817fac66d02d3c34c3ceababa75eb3110"
    }
   }
  },
  {
   "key": "asphalt",
   "source": "scan",
   "m_per_tile": 3,
   "classes": [
    12
   ],
   "contrast": 0.9,
   "normal_k": 1,
   "cavity_k": 1,
   "files": {
    "t2_A": {
     "file": "t2/A_asphalt.ktx2",
     "bytes": 1347603,
     "sha256": "0734848ffb8732627b032ccb28e753dc9c905e8af59229caeabb5feecaa66bb5"
    },
    "t2_B": {
     "file": "t2/B_asphalt.ktx2",
     "bytes": 1210461,
     "sha256": "950c90590b72ac42914c6d5ddbbb1ae74a6b650f4954835b701191c884e45743"
    },
    "t1_A": {
     "file": "t1/A_asphalt.ktx2",
     "bytes": 334505,
     "sha256": "4f7200632f85d9c5ca54c97d1de2464c23cb6a997acc4a6908a8fbbc0a342217"
    },
    "t1_B": {
     "file": "t1/B_asphalt.ktx2",
     "bytes": 288520,
     "sha256": "5ac0a20ef1ecb66b6edeaf1b8acfcf8a7109e93ead8abfaae66984be69d85557"
    }
   },
   "stats": {
    "t2": {
     "mult_mean": [
      1,
      1,
      1
     ],
     "mult_logstd": [
      0.36,
      0.36,
      0.37
     ],
     "normal_mean": [
      -0.001,
      0.001
     ],
     "tilt_deg": 8.7,
     "cavity_mean": 1,
     "height_range_m": 0.0043,
     "c_fine": 0.0157,
     "c_mid": 0.0045
    },
    "t1": {
     "mult_mean": [
      1,
      1,
      1
     ],
     "mult_logstd": [
      0.246,
      0.247,
      0.255
     ],
     "normal_mean": [
      -0.001,
      0.001
     ],
     "tilt_deg": 5.2,
     "cavity_mean": 1,
     "height_range_m": 0.0043,
     "c_fine": 0.0157,
     "c_mid": 0.0045
    }
   },
   "scan": {
    "id": "asphalt_02",
    "author": "Rob Tuytel",
    "url": "https://polyhaven.com/a/asphalt_02",
    "license": "CC0-1.0",
    "resolution": "2k",
    "sha256": {
     "diff": "28f5ba8690553f192c0e5e1a5ff40f34765b4b93f4cc7059b1a3e9c795b6c28c",
     "disp": "943f254ed5e1504131547b35afe3798771cdda33842b7fdc6c0288b8312a44b0",
     "nor_gl": "ffe49db71a0fd34c1e259625df66a302a237597d6ef655307987ec4e45bc6f21"
    },
    "heal": {
     "dark": 0.2,
     "deep": 0.015,
     "frac": 0.153
    }
   }
  },
  {
   "key": "cliff_rock",
   "source": "scan",
   "m_per_tile": 2.7,
   "classes": [],
   "contrast": 1,
   "normal_k": 1,
   "cavity_k": 1,
   "files": {
    "t2_A": {
     "file": "t2/A_cliff_rock.ktx2",
     "bytes": 1248386,
     "sha256": "f61ea13a2c3a87af6349cd739bc35b855f51e791b78b0cfb299edecf2195602e"
    },
    "t2_B": {
     "file": "t2/B_cliff_rock.ktx2",
     "bytes": 1175866,
     "sha256": "f6ed72ddc7b661043c4f49db57fd8a724286d3769420b4ce42b8c603ce5ecb82"
    },
    "t1_A": {
     "file": "t1/A_cliff_rock.ktx2",
     "bytes": 308273,
     "sha256": "5d2117e884fe4f12d5a1d4a2fde7bd2a6536090e28215730a19b42c5bdbd9526"
    },
    "t1_B": {
     "file": "t1/B_cliff_rock.ktx2",
     "bytes": 298918,
     "sha256": "2d2a58491fcc268e2d57ad3bcb5e3c6937e9873f2e8479793b7c7c76c1765b9d"
    }
   },
   "stats": {
    "t2": {
     "mult_mean": [
      1,
      1,
      1
     ],
     "mult_logstd": [
      0.279,
      0.285,
      0.279
     ],
     "normal_mean": [
      0,
      0
     ],
     "tilt_deg": 15,
     "cavity_mean": 1,
     "height_range_m": 0.0957,
     "c_fine": 0.0563,
     "c_mid": 0.0101
    },
    "t1": {
     "mult_mean": [
      1,
      1,
      1
     ],
     "mult_logstd": [
      0.248,
      0.257,
      0.251
     ],
     "normal_mean": [
      0,
      0
     ],
     "tilt_deg": 13.2,
     "cavity_mean": 1,
     "height_range_m": 0.0957,
     "c_fine": 0.0563,
     "c_mid": 0.0101
    }
   },
   "scan": {
    "id": "rock_face_03",
    "author": "Dario Barresi, Rico Cilliers",
    "url": "https://polyhaven.com/a/rock_face_03",
    "license": "CC0-1.0",
    "resolution": "2k",
    "sha256": {
     "diff": "644ee79df7ffbf5f6afc330b64dd3f33794bab8820915fe61ffe0c88ecfd7ece",
     "disp": "5d24ec5a7f4f7333bcf9c158f63d0059d9a3ba234eeff7570a5f6cf2f4522cd5",
     "nor_gl": "a498cef4ba6191f6959b6d03fb835263c77271948264a289af24497ab7111dec"
    }
   },
   "delight_dir": {
    "a": -0.2679,
    "b": -0.1448,
    "corr_before": 0.223,
    "corr_after": 0
   }
  },
  {
   "key": "concrete",
   "source": "scan",
   "m_per_tile": 2.5,
   "classes": [],
   "contrast": 0.8,
   "normal_k": 1,
   "cavity_k": 1,
   "files": {
    "t2_A": {
     "file": "t2/A_concrete.ktx2",
     "bytes": 1165399,
     "sha256": "4173ca6ea9efd0257d6a6192f456e5c895227fd8a3039abe4bdc336c55de2fe9"
    },
    "t2_B": {
     "file": "t2/B_concrete.ktx2",
     "bytes": 1056430,
     "sha256": "a3a85fef39403512f0aa183b1ca30f321ff9d4b71117df85f7c1d9038490376a"
    },
    "t1_A": {
     "file": "t1/A_concrete.ktx2",
     "bytes": 301745,
     "sha256": "d9a9f6eed0e1bed9015f79264d158c2e7895004fc62548448fe52e00191c2d20"
    },
    "t1_B": {
     "file": "t1/B_concrete.ktx2",
     "bytes": 241306,
     "sha256": "96142966667cefccff7627d9b267970bd10e592619aa04274ea887b9b6dbc4c7"
    }
   },
   "stats": {
    "t2": {
     "mult_mean": [
      1,
      1,
      1
     ],
     "mult_logstd": [
      0.191,
      0.177,
      0.154
     ],
     "normal_mean": [
      0,
      0
     ],
     "tilt_deg": 5.1,
     "cavity_mean": 1,
     "height_range_m": 0.0067,
     "c_fine": 0.0162,
     "c_mid": 0.0024
    },
    "t1": {
     "mult_mean": [
      1,
      1,
      1
     ],
     "mult_logstd": [
      0.148,
      0.137,
      0.118
     ],
     "normal_mean": [
      0,
      0
     ],
     "tilt_deg": 3.5,
     "cavity_mean": 1,
     "height_range_m": 0.0067,
     "c_fine": 0.0162,
     "c_mid": 0.0024
    }
   },
   "scan": {
    "id": "brushed_concrete",
    "author": "Dario Barresi, Dimitrios Savva",
    "url": "https://polyhaven.com/a/brushed_concrete",
    "license": "CC0-1.0",
    "resolution": "2k",
    "sha256": {
     "diff": "5af96604b20e29862b449d86981b196b18ba5cbcb8659c451dd8976411a36130",
     "disp": "d56916fb872959a0829ff85b8320a0ea5c0ffe5b6efd51ac4f1e425ca56910ed",
     "nor_gl": "3d1f1c7a5f20a5f7a15f3bc5c5f58c0fdcaf49e71e65a5f17e086b551895c00c"
    }
   }
  },
  {
   "key": "paving",
   "source": "scan",
   "m_per_tile": 2,
   "classes": [],
   "contrast": 0.9,
   "normal_k": 1,
   "cavity_k": 1,
   "files": {
    "t2_A": {
     "file": "t2/A_paving.ktx2",
     "bytes": 1274457,
     "sha256": "f2c3bc23316fefb591b9cf790a5a514752ed954fe994ffc335cee7424b4d2145"
    },
    "t2_B": {
     "file": "t2/B_paving.ktx2",
     "bytes": 1083438,
     "sha256": "db207ca9d777785f681810aca23084736f06077f71f4bbc04745dda33e4a047d"
    },
    "t1_A": {
     "file": "t1/A_paving.ktx2",
     "bytes": 315116,
     "sha256": "b2e4702d461bdeb476a278ee7a4334b03e73586798b28d3b75ed101add220323"
    },
    "t1_B": {
     "file": "t1/B_paving.ktx2",
     "bytes": 271691,
     "sha256": "1fc12fed230f817463b3ea9891569dacee1f0c1b409ce8c68eed8a85acbb6ea5"
    }
   },
   "stats": {
    "t2": {
     "mult_mean": [
      1,
      1,
      1
     ],
     "mult_logstd": [
      0.205,
      0.215,
      0.224
     ],
     "normal_mean": [
      0,
      0
     ],
     "tilt_deg": 6.5,
     "cavity_mean": 1,
     "height_range_m": 0.0067,
     "c_fine": 0.0224,
     "c_mid": 0.0017
    },
    "t1": {
     "mult_mean": [
      1,
      1,
      1
     ],
     "mult_logstd": [
      0.17,
      0.178,
      0.186
     ],
     "normal_mean": [
      0,
      0
     ],
     "tilt_deg": 5.2,
     "cavity_mean": 1,
     "height_range_m": 0.0067,
     "c_fine": 0.0224,
     "c_mid": 0.0017
    }
   },
   "scan": {
    "id": "stone_pavers",
    "author": "Amal Kumar",
    "url": "https://polyhaven.com/a/stone_pavers",
    "license": "CC0-1.0",
    "resolution": "2k",
    "sha256": {
     "diff": "5f8c4ce8fcce17bc69bf82b6054c169f798a4e7820575acfc032ddb0eab19721",
     "disp": "75eaf10f3791362ff66c815e8a62aee2141d8eea6d231d18e8a27249ffd5fa65",
     "nor_gl": "027efb1d8bac5f4116bcddcb99014c0c78432fde66f9d13aeb934e572850c244"
    },
    "roll": [
     0.125,
     0.125
    ]
   }
  },
  {
   "key": "sett",
   "source": "scan",
   "m_per_tile": 1,
   "classes": [],
   "contrast": 0.9,
   "normal_k": 1,
   "cavity_k": 1,
   "files": {
    "t2_A": {
     "file": "t2/A_sett.ktx2",
     "bytes": 1289102,
     "sha256": "e14ca73ba556a4c39e118b7d5e3f49bc91e66404c2dc69fd2593fd901fde503d"
    },
    "t2_B": {
     "file": "t2/B_sett.ktx2",
     "bytes": 879869,
     "sha256": "473b6bbd1814487833802dc0cd5612fa9ef08cb08049d6b47efe0ddeac18b82b"
    },
    "t1_A": {
     "file": "t1/A_sett.ktx2",
     "bytes": 328558,
     "sha256": "fe94bf90f69cfe90e0a36eb753da0207ff0cb1c5b782c056fc0b33aac254a931"
    },
    "t1_B": {
     "file": "t1/B_sett.ktx2",
     "bytes": 233004,
     "sha256": "c1d714698ddc598e5913a8583306ace77ea70df28ae5a2358b61c3136f96ea1c"
    }
   },
   "stats": {
    "t2": {
     "mult_mean": [
      1,
      1,
      1
     ],
     "mult_logstd": [
      0.469,
      0.481,
      0.613
     ],
     "normal_mean": [
      0,
      0
     ],
     "tilt_deg": 8.4,
     "cavity_mean": 1,
     "height_range_m": 0.0159,
     "c_fine": 0.0167,
     "c_mid": 0.0036
    },
    "t1": {
     "mult_mean": [
      1,
      1,
      1
     ],
     "mult_logstd": [
      0.425,
      0.436,
      0.563
     ],
     "normal_mean": [
      0,
      0
     ],
     "tilt_deg": 7.9,
     "cavity_mean": 1,
     "height_range_m": 0.0159,
     "c_fine": 0.0167,
     "c_mid": 0.0036
    }
   },
   "scan": {
    "id": "cobblestone_square",
    "author": "Rob Tuytel",
    "url": "https://polyhaven.com/a/cobblestone_square",
    "license": "CC0-1.0",
    "resolution": "2k",
    "sha256": {
     "diff": "bd411110b889e54902e2a8afbc53f8ee63471970881986ccc55d301502fa9893",
     "disp": "66d38abc5e09d9ccde8635fc5264cba947e9851ff32af6b81747110e1be9e5df",
     "nor_gl": "91fd394e1f67ef6120f0611d5f33a1855484b18040ed53b994d5863e1411e261"
    }
   }
  },
  {
   "key": "ballast",
   "source": "scan",
   "m_per_tile": 2,
   "classes": [],
   "contrast": 1,
   "normal_k": 1,
   "cavity_k": 1,
   "files": {
    "t2_A": {
     "file": "t2/A_ballast.ktx2",
     "bytes": 1343103,
     "sha256": "bb9dd1fde7f7b12049ddd02dc03c98caa9c671e8124543a513d1a41788dd5e60"
    },
    "t2_B": {
     "file": "t2/B_ballast.ktx2",
     "bytes": 1319603,
     "sha256": "164413b82c3ebf5c9f95eddb5482775f60d322804a8697ebf5f2bd378ffd21ac"
    },
    "t1_A": {
     "file": "t1/A_ballast.ktx2",
     "bytes": 334593,
     "sha256": "ec1573f4c04b6efcc8af2e021f65d755102971d094a9f13b17266383207033da"
    },
    "t1_B": {
     "file": "t1/B_ballast.ktx2",
     "bytes": 338592,
     "sha256": "bfb2a98053d63e46aa8ea6d79dc6a95562119863d25f79e023fdb0942bc3ed5d"
    }
   },
   "stats": {
    "t2": {
     "mult_mean": [
      1,
      1,
      1
     ],
     "mult_logstd": [
      0.29,
      0.285,
      0.267
     ],
     "normal_mean": [
      0,
      0
     ],
     "tilt_deg": 31.8,
     "cavity_mean": 1,
     "height_range_m": 0.0183,
     "c_fine": 0.0166,
     "c_mid": 0.0017
    },
    "t1": {
     "mult_mean": [
      1,
      1,
      1
     ],
     "mult_logstd": [
      0.252,
      0.246,
      0.229
     ],
     "normal_mean": [
      0,
      0
     ],
     "tilt_deg": 26.2,
     "cavity_mean": 1,
     "height_range_m": 0.0183,
     "c_fine": 0.0166,
     "c_mid": 0.0017
    }
   },
   "scan": {
    "id": "gravel_stones",
    "author": "Amal Kumar",
    "url": "https://polyhaven.com/a/gravel_stones",
    "license": "CC0-1.0",
    "resolution": "2k",
    "sha256": {
     "diff": "cacad132d39976f66451271b4eeb1e6ee11ecbff2cd3160f2b9d4323aa2b0136",
     "disp": "05e5ced91f3f3785e79ae825916c26ef4597a6c8b4d47a1e23f8eb212a2a174b",
     "nor_gl": "13a0218f69539da3e8f9ad805213ce311a936d30c05558d8e42ebb46fde5b7eb"
    }
   }
  },
  {
   "key": "steps",
   "source": "scan",
   "m_per_tile": 2,
   "classes": [],
   "contrast": 0.8,
   "normal_k": 1,
   "cavity_k": 1,
   "files": {
    "t2_A": {
     "file": "t2/A_steps.ktx2",
     "bytes": 1344411,
     "sha256": "da356b417423a49acec5a8f5904035212a9e61074e04804e3b96a4a0f56151a3"
    },
    "t2_B": {
     "file": "t2/B_steps.ktx2",
     "bytes": 1193637,
     "sha256": "bd00b53b5c3d2524655ae92a417587217ea316fe9691f3c21e3b5ecb0b661847"
    },
    "t1_A": {
     "file": "t1/A_steps.ktx2",
     "bytes": 336049,
     "sha256": "196ea83fe838ec1631206c4cca7a2cad14667d05edab1179c015edcd6a2fd748"
    },
    "t1_B": {
     "file": "t1/B_steps.ktx2",
     "bytes": 278551,
     "sha256": "46111f2a800adc69db014a149b0b198e07887f1f21a8bb531d1b578019c4894b"
    }
   },
   "stats": {
    "t2": {
     "mult_mean": [
      1,
      1,
      1
     ],
     "mult_logstd": [
      0.314,
      0.321,
      0.332
     ],
     "normal_mean": [
      0,
      0
     ],
     "tilt_deg": 6.4,
     "cavity_mean": 1,
     "height_range_m": 0.0046,
     "c_fine": 0.016,
     "c_mid": 0.0046
    },
    "t1": {
     "mult_mean": [
      1,
      1,
      1
     ],
     "mult_logstd": [
      0.267,
      0.267,
      0.275
     ],
     "normal_mean": [
      0,
      0
     ],
     "tilt_deg": 4.4,
     "cavity_mean": 1,
     "height_range_m": 0.0046,
     "c_fine": 0.016,
     "c_mid": 0.0046
    }
   },
   "scan": {
    "id": "concrete_floor_01",
    "author": "Rob Tuytel",
    "url": "https://polyhaven.com/a/concrete_floor_01",
    "license": "CC0-1.0",
    "resolution": "2k",
    "sha256": {
     "diff": "ca24c52dabae67ef49093f91d8f9b9e5328a3b9fcb1327742ff6181ee542e017",
     "disp": "1f7a0076dd979587914552d1fb3407b3ce7e595161a0e456aa7094b485917a5b",
     "nor_gl": "796b010208e346bbeec4c468f286c3892852a454f77cb516d6f4a6e7c240de01"
    }
   }
  }
 ],
 "neutral": {
  "t2": {
   "file": "t2/neutral.ktx2",
   "bytes": 817,
   "sha256": "690eeb65e37f32f4093e73de1c1a7eed070ce46b500adb9a7fcf1e931c2b0e18"
  },
  "t1": {
   "file": "t1/neutral.ktx2",
   "bytes": 685,
   "sha256": "283ced2b5815d722964f37a2f3197bfc3398f0dad7596a0f6bf65350a977e271"
  }
 },
 "class_layer": [
  0,
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  0,
  0,
  0,
  8,
  13,
  10,
  6,
  9
 ],
 "none_classes": [],
 "band_layers": [
  0,
  1,
  5,
  9
 ],
 "path_layers": {
  "1": 11,
  "2": 12,
  "3": 6,
  "4": 13,
  "5": 15,
  "6": 16,
  "7": 17,
  "8": 6,
  "9": 18,
  "10": 19
 },
 "cliff": {
  "layer": 14,
  "host_layers": [
   5,
   4
  ]
 }
}
